import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";

import { Paginator } from "./paginator/paginator";
import {
  DEFAULT_VALUE,
  PAGINATION_INDEXING,
  PAGINATION_PAGE_SIZES,
} from "../../../constants";

export const ExpandableTable = (props) => {
  const {
    data,
    perPage,
    columns,
    totalRows,
    pageNumber,
    handleSorting,
    handlePageChange,
    expandRowRenderer,
    onRowExpandToggled,
    defaultSortingField,
    defaultSortingOrder,
    handlePerRowsChange,
    numberOfRowsPerPage,
    paginationDefaultPage,
    expandableRows = true,
    handleRowPerPageOption,
    enableServerSorting = false,
    expandOnRowClicked = false,
    activatePagination = false,
    expandOnRowDoubleClicked = false,
    activateServerPagination = false,
    expandableRowsHideExpander = false,
    //Function(row) => boolean to control whether a given row is expanded (controlled expansion)
    expandableRowExpanded,
    noDataComponent = (
      <div className="w-100 text-center py-2 no-data">No data to display</div>
    ),
  } = props;

  const curPage = useRef(pageNumber || PAGINATION_INDEXING.FIRST_PAGE_NUMBER);

  const [activePage, setActivePage] = useState(pageNumber || PAGINATION_INDEXING.FIRST_PAGE_NUMBER);

  const rowsPerPage = numberOfRowsPerPage || PAGINATION_PAGE_SIZES.COMPACT;
  const count = totalRows || DEFAULT_VALUE;
  const totalPages = Math.ceil(count / rowsPerPage);

  // Request each selected page once using the server's page index.
  useEffect(() => {
    if (handlePageChange && curPage.current !== activePage) {
      curPage.current = activePage;
      handlePageChange(activePage - PAGINATION_INDEXING.PAGE_INDEX_OFFSET);
    }
  }, [activePage, handlePageChange]);

  // Follow page resets from filters without requesting the page again.
  useEffect(() => {
    const nextPage = pageNumber || PAGINATION_INDEXING.FIRST_PAGE_NUMBER;
    curPage.current = nextPage;
    setActivePage(nextPage);
  }, [pageNumber]);

  return (
    <div className="px-4">
      <DataTable
        responsive
        data={data}
        columns={columns}
        onSort={handleSorting}
        persistTableHead={true}
        paginationPerPage={perPage}
        expandableRows={expandableRows}
        pagination={activatePagination}
        paginationTotalRows={totalRows}
        onChangePage={(nextPage) => setActivePage(nextPage)}
        sortServer={enableServerSorting}
        noDataComponent={noDataComponent}
        defaultSortAsc={defaultSortingOrder}
        expandOnRowClicked={expandOnRowClicked}
        onRowExpandToggled={onRowExpandToggled}
        expandableRowExpanded={expandableRowExpanded}
        defaultSortFieldId={defaultSortingField}
        onChangeRowsPerPage={handlePerRowsChange}
        expandableRowsComponent={expandRowRenderer}
        paginationServer={activateServerPagination}
        paginationDefaultPage={paginationDefaultPage}
        expandOnRowDoubleClicked={expandOnRowDoubleClicked}
        paginationRowsPerPageOptions={handleRowPerPageOption}
        expandableRowsHideExpander={expandableRowsHideExpander}
        className="react-app-expandable-table"
      />
      <hr className="py-0 my-0" />
      <Paginator
        totalRows={count}
        size={rowsPerPage}
        totalPages={totalPages}
        rowsPerPage={data.length}
        activatePage={setActivePage}
        activePageNumber={activePage}
      />
    </div>
  );
};
